module.exports = __webpack_public_path__ + "static/img/b13.5a9505f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b13.jpg
// module id = IRkS
// module chunks = 1